import React from "react";
import { ErrorModalIcon } from "../../assets";

interface ErrorModalProps {
  message: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ message }) => {
  return (
    <div className="modal modalSuccessfull modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <div className="modal__header--logo">
              <ErrorModalIcon />
            </div>
          </div>
          <div className="modal__body">
            <h4 className="promptMessage">{message}</h4>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default ErrorModal;
